import { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import { IState } from './modifying.types';

const getModifyingStore = (state: RootState) => state.modifying as IState;

export const isModifyingInProgress = createSelector(getModifyingStore, (state) => state.isModifyingInProgress);
